import moment from "moment";
import HelperMixin from "../../../Shared/HelperMixin.vue";
import PaginationHelper from "../../../Shared/PaginationHelper.vue";

export default {
    name: "Charging",
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (!this.requireUserType([1])) return;

        this.GetInfo();
    },

    filters: {
        moment: function (date) {
            if (!date) return "—";
            return moment(date).format("DD/MM/YYYY");
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,

            ScreenTitle: "شحن الكروت",
            ScreenTitleSingle: "عملية شحن",

            Info: [],
            Statistics: 0,

            Search: "",
            From: "",
            To: ""
        };
    },

    methods: {
        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (this.From)
                this.From = this.ChangeDate(this.From);

            if (this.To)
                this.To = this.ChangeDate(this.To);

            if (!this.Search)
                this.$blockUI.Start();

            this.$http
                .GetVoucherCardsCharging(
                    this.pageNo,
                    this.pageSize,
                    this.Search,
                    this.From,
                    this.To
                )
                .then((response) => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    const data = response.data || {};
                    this.Info = data.info || [];
                    this.pages = data.count || 0;

                    const s = data.statistics || {};
                    this.Statistics = {
                        count: s.count ?? s.Count ?? 0,
                        totalValue: s.totalValue ?? s.TotalValue ?? 0
                    };
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                    this.Statistics = 0;
                });
        },

        ChannelName(chanel) {
            if (chanel == 1) return "تطبيق ويب";
            return "—";
        },

        Refresh() {
            this.Search = "";
            this.From = "";
            this.To = "";
            this.GetInfo(1);
        }
    }
};
